import { useEffect } from 'react';

import {
  CorporateAccount,
  CorporateAccountDetailsData,
} from '../accountsServices/CorporateAccountsService';

const useSaveDataForEditCorporateAccount = (
  accountForEditing: CorporateAccount,
  setSaved: (value: boolean) => void,
  saveData: (groupName: CorporateAccountDetailsData['companyName']) => void,
  saved?: boolean
) => {
  useEffect(() => {
    if (!saved) {
      saveData(accountForEditing.companyName);
      setSaved(true);
    }
  }, [accountForEditing, saveData, saved, setSaved]);
};

export default useSaveDataForEditCorporateAccount;
